/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PassengerStatus = {
    PickedUp: 'PickedUp',
    DroppedOff: 'DroppedOff',
    Absent: 'Absent',
    None: 'None'
} as const;
export type PassengerStatus = typeof PassengerStatus[keyof typeof PassengerStatus];

